var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import i18next from 'i18next';
import styled from 'styled-components';
import { useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import { SentryProvider } from "../../providers";
var MissingBtf = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: red;\n"], ["\n  color: red;\n"])));
var getMissingBtf = function (btf) {
    useEffect(function () {
        SentryProvider.captureError(new Error("Missing translation [btf => ".concat(btf, "; language => ").concat(i18next.language, "]")), null);
    }, []);
    return _jsxs(MissingBtf, { children: ["[", _jsx("span", { style: { whiteSpace: 'nowrap' }, children: btf }), "]"] });
};
var translateBtf = function (btf, params) {
    return _jsx("span", { style: { whiteSpace: "pre-line" }, dangerouslySetInnerHTML: { __html: i18next.t(btf, params) } });
};
export var TrHelper = {
    i: function (btf, params) { return TrHelper.exists(btf) ? translateBtf(btf, params) : getMissingBtf(btf); },
    renderToString: function (node) { return ReactDOMServer.renderToStaticMarkup(node).replace(/<[^>]*>?/gm, ''); },
    exists: function (btf) { return i18next.exists(btf); },
};
/**
 * @deprecated
 * @param props
 * @constructor
 */
export var Tr = function (props) {
    var btf = props.btf, params = props.params;
    var exists = TrHelper.exists(btf);
    if (!exists)
        return getMissingBtf(btf);
    var translation = TrHelper.i(btf, params);
    return _jsx("span", { dangerouslySetInnerHTML: { __html: translation.toString() } });
};
var templateObject_1;
//# sourceMappingURL=translate.component.js.map